import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { AuthenticationService, SpinnerService } from '../services';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';
    loginerrormsg: boolean = false;
    forgotPassword: FormGroup;
    ForgotpasswordErMsg: boolean = false;
    ForgotpasswordSuccessMsg: boolean = false;
    displayDialog: boolean;
    URL: any;
    private subscription: Subscription = new Subscription();
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private spinnerService: SpinnerService,
    ) { }

    ngOnInit() {
            this.loginForm = this.formBuilder.group({
                username: ['', Validators.required],
                password: ['', Validators.required]
            });

            // // reset login status
            // var user = this.authenticationService.getAuthorizationToken();
            // this.authenticationService.logout(user);

            // get return url from route parameters or default to '/'
            this.forgotPassword = this.formBuilder.group({
                Uname: ['', Validators.required],
                EmailSent: false
            });
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
       
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
        this.spinnerService.start();
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(
            data => {
                this.loginerrormsg=false;
                this.router.navigate(['/dealer/home']);
                this.spinnerService.stop();
            },
            error => {
                this.error = error;
                this.loginerrormsg=true;
                this.loading = false;
                this.spinnerService.stop();
            });
    }

    ForgotPassword() {
        this.displayDialog = true;
        this.forgotPassword.reset();
        this.ForgotpasswordErMsg = false;
        this.ForgotpasswordSuccessMsg = false;
    }
    Cancel() {
        this.forgotPassword.reset();
        this.displayDialog = false;
        this.ForgotpasswordErMsg = false;
    }
    Submit() {
        debugger;
        this.spinnerService.start();
            this.URL = window.location.origin;
        this.subscription.add(this.authenticationService.UsernameCheck(this.forgotPassword.value.Uname,this.URL).subscribe(
            (data) => {
                debugger;
                if (data == false) {
                    //this.displayerrorInfo=true;
                    //alert("Email not available.");
                    this.ForgotpasswordErMsg = true;
                    this.ForgotpasswordSuccessMsg = false;
                }
                else {
                    //alert("Mail sent to your registered email address.")
                    this.forgotPassword.patchValue({
                        EmailSent: true,
                        Uname: ''
                    });
                    this.ForgotpasswordErMsg = false;
                    this.ForgotpasswordSuccessMsg = true;
                }
                this.spinnerService.stop();
                //this.displayDialog = false;
            },
            error => {
                debugger;
                this.ForgotpasswordErMsg = true;
                this.ForgotpasswordSuccessMsg = false;
                this.spinnerService.stop();
            }));
        }
}
